module.exports = __webpack_public_path__ + "images/emoji/feet.9700435643688292e592.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/feet.png
// module id = t0jS
// module chunks = 1